// @ts-nocheck
export enum SubAvailabilityTypes {
    InStock = 0,
    Backorder = 1,
    WhileSuppliesLast = 2,
    OutOfStock = 3,
}
